module.exports = __webpack_public_path__ + "img/FullLogoV3.62b02724.webp";